export const enUSFile = {
  "interactionModel": {
    "languageModel": {
      "invocationName": "bank agent",
      "intents": [
        {
          "name": "AMAZON.CancelIntent",
          "samples": ["cancel"]
        },
        {
          "name": "AMAZON.HelpIntent",
          "samples": ["help"]
        },
        {
          "name": "AMAZON.StopIntent",
          "samples": ["stop"]
        },
        {
          "name": "GetBalanceIntent",
          "slots": [
            {
              "name": "inst_name",
              "type": "INST_NAME"
            },
            {
              "name": "acc_type",
              "type": "ACC_TYPE"
            }
          ],
          "samples": [
            "get balance on {acc_type} account",
            "get balance on my {acc_type} account",

            "get balance on {acc_type} accounts",
            "get balance on my {acc_type} accounts",
            "get balance on all {acc_type} accounts",
            "get balance on all my {acc_type} accounts",

            "get balance on {inst_name} account",
            "get balance on my {inst_name} account",

            "get balance on {inst_name} accounts",
            "get balance on my {inst_name} accounts",
            "get balance on all {inst_name} accounts",
            "get balance on all my {inst_name} accounts",

            "get balance on {inst_name} {acc_type}",
            "get balance on my {inst_name} {acc_type}",

            "get balance on {inst_name} {acc_type} account",
            "get balance on my {inst_name} {acc_type} account",

            "get balance on {inst_name} {acc_type} accounts",
            "get balance on my {inst_name} {acc_type} accounts",
            "get balance on all {inst_name} {acc_type} accounts",
            "get balance on all my {inst_name} {acc_type} accounts"
          ]
        },
        {
          "name": "AMAZON.NavigateHomeIntent",
          "samples": []
        },
        {
          "name": "AMAZON.YesIntent",
          "samples": [
            "Yes",
            "Ok",
            "Yep",
            "Sure"
          ]
        },
        {
          "name": "AMAZON.NoIntent",
          "samples": [
            "No",
            "Nope"
          ]
        },
        {
          "name": "RunInDemoIntent",
          "slots": [],
          "samples": [
            "Sample",
            "Demo"
          ]
        }
      ],
      "types": [
        {
          "name": "INST_NAME",
          "values": [
            {
              "name": {
                "value": "HUNTINGTON BANK"
              }
            },
            {
              "name": {
                "value": "CHARLES SCHWAB"
              }
            },

            {
              "name": {
                "value": "CREDIT SUISSE"
              }
            },
            {
              "name": {
                "value": "BEST BUY"
              }
            },
            {
              "name": {
                "value": "AMAZON"
              }
            },
            {
              "name": {
                "value": "WELLS FARGO"
              }
            },

            {
              "name": {
                "value": "CHASE"
              }
            },
            {
              "name": {
                "value": "CITI"
              }
            },
            {
              "name": {
                "value": "BANK OF AMERICA"
              }
            },
            {
              "name": {
                "value": "SUNTRUST"
              }
            },
            {
              "name": {
                "value": "AMERICAN EXPRESS"
              }
            },
            {
              "name": {
                "value": "US BANK"
              }
            },
            {
              "name": {
                "value": "CAPITAL ONE"
              }
            },
            {
              "name": {
                "value": "PNC"
              }
            },
            {
              "name": {
                "value": "USAA"
              }
            },
            {
              "name": {
                "value": "TD BANK"
              }
            },
            {
              "name": {
                "value": "REGIONS BANK"
              }
            },
            {
              "name": {
                "value": "NAVY FEDERAL CREDIT UNION"
              }
            },
            {
              "name": {
                "value": "BB AND T"
              }
            },
            {
              "name": {
                "value": "FIDELITY"
              }
            }
          ]
        },
        {
          "name": "ACC_TYPE",
          "values": [
            {
              "name": {
                "value": "CREDIT CARD"
              }
            },
            {
              "name": {
                "value": "CREDIT"
              }
            },
            {
              "name": {
                "value": "SAVINGS"
              }
            },
            {
              "name": {
                "value": "CHECKING"
              }
            }
          ]
        }
      ]
    }
  }
}